import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-one',
  templateUrl: './home-page-one.component.html',
  styleUrls: ['./home-page-one.component.scss']
})
export class HomePageOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
